import { RootState, ThunkDispatch } from "core-integration/src/store";
import { getURL } from "core-integration/src/store/urls/reducers";
import { fetchURL } from "core-integration/src/store/urls/thunks";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Parser from "rss-parser";
import filterOnSSL from "../components/scout/filterOnSSL";

const parser = new Parser();

type UseRssProviderDataArgs = {
  url: string;
  numberOfArticles: number;
};

export const useRssProviderData = ({
  url,
  numberOfArticles,
}: UseRssProviderDataArgs) => {
  const [providerData, setProviderData] = useState<Parser.Item[] | null>(null);

  const reduxDispatch = useDispatch<ThunkDispatch>();

  // Fetch RSS
  useEffect(() => {
    reduxDispatch(fetchURL(url));
  }, [reduxDispatch, url]);

  // Get raw RSS content
  const content = useSelector((state: RootState) => getURL(state, url));

  // Parse RSS data
  useEffect(() => {
    const parseContent = async () => {
      try {
        const feed = await parser.parseString(content.text);
        if (feed && feed.items) {
          const filteredSslFeedItems = filterOnSSL(feed.items).splice(
            0,
            numberOfArticles,
          );

          setProviderData(filteredSslFeedItems);
        }
      } catch (e) {
        console.error("Error parsing RSS feed:", e);
      }
    };
    if (content) {
      parseContent();
    }
  }, [content, numberOfArticles]);

  return { providerData, content };
};
